/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 */

import { safeFilterActions } from '@zcode/utils'
import { walkscoreReducer } from './reducers/index'
import { whitelist } from './whitelist'

export const walkscoreRootReducer = safeFilterActions(walkscoreReducer, whitelist)
